<template>
  <div class="detail">
    <div class="header">
      工单信息
      <span v-if="workOrderInfo.workOrder.businessType == 33">
        ({{
          workOrderInfo.workOrder.followBusinessType == 1
            ? `医生:${workOrderInfo.workOrder.ucDoctorName}`
            : `患者:${workOrderInfo.workOrder.ucPatientName}`
        }})
      </span>
    </div>
    <div class="detail_label">
      <div
        class="detail_label_info"
        v-for="item in workorderDetailConfig"
        :key="item.label"
        :class="item.class"
      >
        <span class="item_label">{{ item.label }}</span>
        <span class="item_content">
          {{
            item.customRender
              ? item.customRender(workOrderInfo.workOrder)
              : workOrderInfo.workOrder[`${item.prop}`] || '--'
          }}
        </span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { workorderDetailConfig } from './config'
import { defineProps, ref, defineEmits, watch } from 'vue'
import { getBDSubTaskDetail } from '@/api/Todo/bdWorkorder'

const props = defineProps({
  workOrderId: {
    type: [String, Number],
    default: ''
  },
  id: {
    type: [String, Number],
    default: ''
  }
})
const workOrderInfo = ref({
  workOrder: {}
})

watch(
  () => [props.workOrderId, props.id],
  val => {
    val && subTaskDetail()
  },
  { immediate: true }
)

// 复诊提醒工单子工单详情
function subTaskDetail() {
  getBDSubTaskDetail({
    workOrderId: props.workOrderId
  })
    .then((res = []) => {
      workOrderInfo.value.workOrder = res?.find(item => item.id === props.id) ?? {}
    })
    .finally(() => {
      emit('orderFinish')
    })
}

const emit = defineEmits(['orderFinish'])
</script>
<style scoped lang="scss">
.detail {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  padding: 2px 6px;
  .detail_label {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    grid-template-rows: repeat(2, minmax(44px, auto));
    list-style: none;
    margin: 0;
    padding-left: 0;
    // grid-gap: 5px 0;
    position: relative;
    margin-bottom: 30px;

    &_info {
      &.large {
        // 左边框所在网格线
        grid-column-start: 1;
        // 右边框所在网格线
        grid-column-end: 4;
      }

      font-size: 14px;
      padding: 20px 0 20px 16px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
      // 第一列左对齐
      &.nopadding {
        padding-left: 0;
      }
      // 最后一列不要边框
      &.noborder .item_content:after,
      &:nth-child(3n) .item_content:after {
        width: 0;
      }
      &.nobottom {
        border-bottom: 0;
      }
      .item_label {
        font-weight: 550;
        flex-shrink: 0;
        margin-right: 3px;
        color: #999999;
      }
      .item_content {
        font-weight: 400;
        color: #666666;
        flex: auto;
        width: 80%;
        z-index: 2;
        font-weight: bold;
        position: relative;
        &:after {
          content: '';
          display: block;
          width: 1px;
          background: #e8e8e8;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
  }
}
</style>
